// extracted by mini-css-extract-plugin
module.exports = {"root":"IdentifiersPage_root__1e_h_","body":"IdentifiersPage_body__wgSHy"};